export const reconcileProductUpdate = async ({
  updatedProduct,
  fallbackProduct,
  productId,
  applyCatalogEvent,
  refreshProducts,
}) => {
  const product = updatedProduct?.id
    ? updatedProduct
    : { id: productId, ...(fallbackProduct || {}) };

  applyCatalogEvent?.({
    action: 'update-product',
    productId,
    product,
  });

  // A basis conversion updates every VarietyPrice and branch rule, while the
  // product PATCH response intentionally contains only product metadata. Pull
  // the catalog again before reopening the detail/editor so it cannot combine
  // the new effective basis with stale child pricing rows.
  if (updatedProduct?.pricingBasisConversion) {
    await refreshProducts?.();
  }

  return product;
};
